export const ACTION_CODE = 'REFERENCE' + '_ACTION';
